import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

import { environment } from '../../../../environments/environment';

// Scoop.it embed integration object.
declare let fct_stemebd_11706682: any;
declare let fct_stemebd_2191065: any;
declare let fct_stemebd_13178169: any;
declare let fct_stemebd_13209469: any;
declare let fct_stemebd_13217298: any;
declare let fct_stemebd_13184960: any;
declare let fct_stemebd_11784805: any;
declare let fct_stemebd_13716507: any;
declare let fct_stemebd_13819933: any;
declare let fct_stemebd_13827249: any;
declare let fct_stemebd_14231315: any;
declare let fct_stemebd_14885021: any;
declare let fct_stemebd_14889174: any;
declare let fct_stemebd_15123056: any;
declare let fct_stemebd_15485848: any;
declare let fct_stemebd_15541239: any;
declare let fct_stemebd_15541594: any;
declare let fct_stemebd_15753338: any;
declare let fct_stemebd_16724320: any;
declare let fct_stemebd_16724378: any;
declare let fct_stemebd_16724382: any;

// declare let fct_stemebd_: any;

@Component({
    selector: 'app-wall',
    templateUrl: './wall.component.html',
})
export class WallComponent implements OnInit, OnChanges {
    @Input() idTopic: number;
    scoopItTopics: any;
    topicSelected: any;

    @Input() visible = false;

    constructor() {}
    ngOnChanges(changes: SimpleChanges) {
        this.visible = changes.visible.currentValue;
        this.getTopicFromScoopIt();
    }

    ngOnInit() {
        this.scoopItTopics = environment.scoopItTopics;
        this.topicSelected = this.getSelectedTopic();

        // Initiate Scoop.it curation integration.
        this.getTopicFromScoopIt();
    }

    getTopicFromScoopIt() {
        switch (this.idTopic) {
            case 11706682:
                new fct_stemebd_11706682();
                break;
            case 2191065:
                new fct_stemebd_2191065();
                break;
            case 13178169:
                new fct_stemebd_13178169();
                break;
            case 13209469:
                new fct_stemebd_13209469();
                break;
            case 13217298:
                new fct_stemebd_13217298();
                break;
            case 13184960:
                new fct_stemebd_13184960();
                break;
            case 11784805:
                new fct_stemebd_11784805();
                break;
            case 13716507:
                new fct_stemebd_13716507();
                break;
            case 13819933:
                new fct_stemebd_13819933();
                break;
            case 13827249:
                new fct_stemebd_13827249();
                break;
            case 14231315:
                new fct_stemebd_14231315();
                break;
            case 14885021:
                new fct_stemebd_14885021();
                break;
            case 14889174:
                new fct_stemebd_14889174();
                break;
            case 15123056:
                new fct_stemebd_15123056();
                break;
            case 15485848:
                new fct_stemebd_15485848();
                break;
            case 15541239:
                new fct_stemebd_15541239();
                break;
            case 15541594:
                new fct_stemebd_15541594();
                break;
            case 15753338:
                new fct_stemebd_15753338();
                break;
            case 16724320:
                new fct_stemebd_16724320();
                break;
            case 16724378:
                new fct_stemebd_16724378();
                break;
            case 16724382:
                new fct_stemebd_16724382();
                break;
            default:
                break;
        }
    }

    getSelectedTopic(): any {
        for (const topic of this.scoopItTopics) {
            if (topic.idTopic == this.idTopic) return topic;
        }

        return this.topicSelected[0];
    }
}
